import React from 'react';
import JobList from './JobList';

const Cv = () => {
  return (
    <div>
      <JobList />
    </div>
  )
}

export default Cv;